import { InitializeChatBot, SetChatBotMetadata } from '../../vendor/chatbot'

class ChatbotWrapperInternal {
  constructor() {
    this.initialized = false
  }

  init(loggedInUser, accessToken) {
    if (this.initialized) {
      return
    }

    window.duet?.unhide()

    if (!window.duet) {
      InitializeChatBot(loggedInUser, accessToken)
    } else {
      SetChatBotMetadata(loggedInUser, accessToken)
    }

    this.initialized = true
  }

  async hide() {
    window.duet?.close()
    window.duet?.hide()
  }
}

export const ChatbotWrapper = new ChatbotWrapperInternal()